export const FullDealMobileAppActionsTexts = {
  getInApp: 'Подобрать займ в приложении',
  continueWebsite: 'Продолжить на сайте',
};
